import MuiSelect from './MuiSelect';

export default MuiSelect;
